import { createRouter, createWebHistory } from 'vue-router'
import NProgress from 'nprogress/nprogress'
import store from '@state/store'
import routes from './routes'
import { redirectToOlLogin } from '@common/AuthServiceOidc'

const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { left: 0, top: 0 }
    }
  },
})

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch((error) => {
    if (!error.message.includes('redundant navigation')) throw error
  })
}

router.beforeEach(async (routeTo, routeFrom, next) => {
  if (routeFrom.name !== null) {
    NProgress.start()
  }

  const authRequired = routeTo.matched.some((route) => route.meta.authRequired)

  if (!authRequired || store.state.auth?.loggingInStatus === 'processing') return next()

  if (store.getters['auth/loggedIn']) {
    return store
      .dispatch('auth/checkAuth')
      .then(async () => {
        if (!store.state.global?.featureFlagsLoaded) {
          await store.dispatch('global/getFeatureFlags')
        }
        next()
      })
      .catch(() => {
        // Token renewal and logout are handled by the API/auth services. Abort
        // only this navigation so a transient account-check failure cannot
        // restart SSO and discard the page the user was viewing.
        next(false)
      })
  }

  redirectToOlLogin()
})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              if (routeFrom.name === args[0].name) {
                NProgress.done()
              }
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          resolve()
        }
      })
    }
  } catch (error) {
    return
  }

  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
